import PicklistMetadata from "../PicklistMetadata";

class DocumentTypeGroupPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "DocumentTypeGroup";
        this.bounded = true;
        this.enterpriseComponent = "PickList Generic";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.searchSpecification = null;
        this.sortSpecification = null;
        this.static = true;
        this.typeField = "Type";
        this.typeValue = "DocumentTypeGroup";
        this.typeValue2 = null;
        this.visibilityType = null;
    }
}

export default DocumentTypeGroupPicklistMetadata;
